
// 上账科目
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
					@reload="$reloadHandle" @goBackIndex="goBackIndex"/>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" style="height: calc(100vh - -35px);">
					<vxe-grid
					:stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%"
					ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
						@custom="$vxeTableUtil.customHandle">

						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus"
										@click="openEditDialog" v-if="fin_subject_add">新增</vxe-button>
								</div>
								<div class="fr">
<!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--										status="primary" plain>重置</vxe-button>-->
									<vxe-button status="warning" icon="el-icon-search" class="button-sty"
										@click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
								<vxe-form-item title="科目编码:" field="code">
									<template v-slot>
										<el-input v-model="formData.code" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="科目名称:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
						<template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";
export default {
  name: 'account',

  mixins: [indexPageMixins],
	components: { editView, pager },
	data() {
		return {
      fin_subject_edit: false,
      fin_subject_add: false,
      total: 0,
			activeName: 'second',
			dataId: 0,
      getPageDataUrl: '/basic/basFinSubject/getListPage',
			vxeOption: {},
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
        finCode: '',  // 科目编码
        finName: '',  // 科目名称
      },

			formData: {
				name: '',
        code: ''
			},
			pageSizes: [10, 20, 100],

      showEdit: false,
      columns: [
        { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
        { title: '科目编码', field: 'finCode', width: 130, },
        { title: '科目名称', field: 'finName', width: 130, },
        { title: '计算符号', field: 'symbols', width: 80, slots: {
            default: ({ row }) => {
              if (row.symbols == -1) {
                return [
                  <div>
                    <span>-</span>
                  </div>
                ];
              } else if (row.symbols == 0) {
                return [
                  <div>
                    <span>不加不减</span>
                  </div>
                ];
              }else if (row.symbols ==1) {
                return [
                  <div>
                    <span>+</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '收款银行名称', field: 'inBankName', width: 150, },
        { title: '收款银行帐户名称', field: 'inBankAccountName', width: 150, },
        { title: '收款银行帐号', field: 'inBankAccount', width: 150, },
        { title: '是否保证金科目', field: 'isDeposit', width: 130, slots: {
            default: ({ row }) => {
              if (row.isDeposit == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isDeposit == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '是否配件期初科目', field: 'isPartsBalance', width: 130, slots: {
            default: ({ row }) => {
              if (row.isPartsBalance == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isPartsBalance == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '是否配件打款科目', field: 'isPartsMoney', width: 130, slots: {
            default: ({ row }) => {
              if (row.isPartsMoney == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isPartsMoney == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '是否配件授信科目', field: 'isPartsCreditMoney', width: 130, slots: {
            default: ({ row }) => {
              if (row.isPartsCreditMoney == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isPartsCreditMoney == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '是否网点可选', field: 'siteChoose', width: 130, slots: {
            default: ({ row }) => {
              if (row.siteChoose == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.siteChoose == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '启用', field: 'usable', width: 90, slots: {
            default: ({ row }) => {
              if (row.usable == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.usable == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
        { field: 'createTime', title: '创建时间', width: 150 },
        { title: '创建人', field: 'createBy', width: 150, },
        { width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({ row }) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-edit" />
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ]
		};
	},
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.getTableData()
    //   }
    // }
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.fin_subject_edit = this.permissions['fin_subject_edit']
    this.fin_subject_add = this.permissions['fin_subject_add']
  },
	methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.finCode = this.formData.code
      this.requestParam.finName = this.formData.name
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.formData = {}
      this.requestParam.searchCount = false
      this.requestParam.finName = ''
      this.requestParam.finCode = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
















		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
	}
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}</style>

